export function getImagePath (url: string, size: string) {
    let urlSplitted = url.split(".");
    let extension = urlSplitted[urlSplitted.length-1]
    let replaced = url.replace(`.${extension}`, `_${size}.${extension}`);
    return replaced;
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/utils/pathHelper.ts